export default function Footer() {
  return (
    <footer className="p-4 text-center text-sm text-gray-500 dark:text-gray-400 bg-black/5">
      © {new Date().getFullYear()} Gihan Liyanage. All rights reserved.
    </footer>
  );
}
